import {
  DiscoveryApi,
  IdentityApi,
  OAuthApi,
} from '@backstage/core-plugin-api';
import {
  AzDevopsApi,
  ProjectList,
  ProjectTeams,
  TeamMemberMeta,
} from '../types';
import {
  ADORequestMiddleware,
  IADORequestMiddleware,
} from '@dewise-devex/backstage-plugin-azdevops-common';

/** @public */
export class AzDevOpsClient implements AzDevopsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly azDevOpsPluginKey = 'azdevops';
  private readonly adoMiddleware: IADORequestMiddleware;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    authApi: OAuthApi;
    identityApi: IdentityApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.adoMiddleware = new ADORequestMiddleware({
      identityApi: options.identityApi,
      authApi: options.authApi,
      adoApiId: '499b84ac-1321-427f-aa17-267ca6975798',
    });
  }

  async getProjects(): Promise<ProjectList> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.azDevOpsPluginKey,
    )}/projects`;

    return await this.adoMiddleware.request(url);
  }

  async getTeamsByProject(projectId: string): Promise<ProjectTeams> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.azDevOpsPluginKey,
    )}/project/${projectId}/teams`;

    return await this.adoMiddleware.request(url);
  }

  async getTeamMembers(projectId: string): Promise<TeamMemberMeta[]> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.azDevOpsPluginKey,
    )}/project/${projectId}/teams/members`;

    return await this.adoMiddleware.request(url);
  }

  async workItemsByQuery(
    project: string,
    team: string,
    top: number,
  ): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.azDevOpsPluginKey,
    )}/project/${project}/team/${encodeURI(team)}/workitems/${top}`;

    return await this.adoMiddleware.request(url, {
      method: 'POST',
    });
  }

  async updateWorkItem(id: number, state: string): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.azDevOpsPluginKey,
    )}/workitem/${id}/project/state/${state}`;

    return await this.adoMiddleware.request(url, { method: 'PATCH' });
  }

  async getWorkItemTypes(project: string): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.azDevOpsPluginKey,
    )}/project/${project}/workitemtypes`;

    return await this.adoMiddleware.request(url);
  }

  async getWorkItemStateByType(
    project: string,
    workItemtype: string,
  ): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.azDevOpsPluginKey,
    )}/workitem/project/${project}/type/${workItemtype}`;

    return await this.adoMiddleware.request(url);
  }

  async getTeamMembersDayOff(project: string): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.azDevOpsPluginKey,
    )}/project/${project}/members/daysOff`;

    return await this.adoMiddleware.request(url);
  }
}
